import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field-table" }
const _hoisted_2 = ["colspan", "rowspan"]

import { cloneDeep } from 'lodash';
import { computed, onMounted, ref } from 'vue';

import useTableCatalogs from 'SharedComponents/Fields/composables/useTableCatalogs';
import { HandsontableCellType } from 'SharedDir/constants/field-types';
import { HeaderCellType, TableColumnType } from 'SharedDir/declarations/fields';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TableValue' },
  __name: 'TableValue',
  props: {
    label: {},
    headers: {},
    columns: {},
    rows: {}
  },
  setup(__props: any) {



const props = __props;

const { catalogsOptions, loadCatalogs } = useTableCatalogs();

const catalogsAreLoaded = ref(false);

function resolveColumnValue(row: Record<string, null | number | string>, column: TableColumnType) {
  const rawValue = row[column.slug];
  if (!rawValue) {
    return '';
  }
  if (column.type === HandsontableCellType.catalog && column.catalogSlug) {
    const catalogValues = catalogsOptions.value[column.catalogSlug] ?? [];
    const value = catalogValues.find((catalogValue) => catalogValue.id === rawValue);
    if (value) {
      return value.name;
    }
    return catalogsAreLoaded.value
      ? `Значение "${rawValue}" не найдено в справочнике`
      : 'Получаем значения ...';
  }

  return rawValue;
}

function makeResolvedRow(row: Record<string, null | number | string>) {
  const resolvedRow = cloneDeep(row);
  props.columns.forEach((column) => {
    resolvedRow[column.slug] = resolveColumnValue(resolvedRow, column);
  });
  return resolvedRow;
}

const resolvedValues = computed(() => props.rows.map(makeResolvedRow));

onMounted(async () => {
  await loadCatalogs(props.columns);
  catalogsAreLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("caption", null, _toDisplayString(_ctx.label), 1),
    _createElementVNode("thead", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, i) => {
        return (_openBlock(), _createElementBlock("tr", { key: i }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(header, (cell, j) => {
            return (_openBlock(), _createElementBlock("th", {
              key: j,
              colspan: cell.colspan,
              rowspan: cell.rowspan
            }, _toDisplayString(cell.label), 9, _hoisted_2))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: row.$rowSlug
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createElementBlock("td", { key: column }, _toDisplayString(resolvedValues.value[index][column.slug]), 1))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})